import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { type LocalVariantSpecsFragment } from '../../../api/fragments/LocalVariantSpecs';
import {
    UpdateVariantImageOrderingDocument,
    type UpdateVariantImageOrderingMutation,
    type UpdateVariantImageOrderingMutationVariables,
} from '../../../api/mutations/updateVariantImageOrdering';
import { type FormValues } from '../AddVehiclePage/AddVariantPage/types';
import { hasOrderingChange } from './helper';

const useVaraintImagesOrdering = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (
            variantId: string,
            values: FormValues,
            initialValues: LocalVariantSpecsFragment,
            uploadedImages: any[]
        ) => {
            const orderChanged = hasOrderingChange(initialValues, values);
            if (orderChanged) {
                if (uploadedImages?.length > 0) {
                    const orderedIdList = uploadedImages
                        .map(value => {
                            if (value.__typename === 'UploadedFileWithPreview') {
                                return value.id;
                            }
                            const {
                                data: {
                                    uploadedData: { uploadedFile },
                                },
                            } = value;
                            if (uploadedFile && uploadedFile.__typename === 'UploadedFile') {
                                return uploadedFile.id;
                            }

                            return null;
                        })
                        .filter(Boolean);

                    return apolloClient.mutate<
                        UpdateVariantImageOrderingMutation,
                        UpdateVariantImageOrderingMutationVariables
                    >({
                        mutation: UpdateVariantImageOrderingDocument,
                        variables: { variantId, orderedImageIds: orderedIdList },
                    });
                }
            }

            return Promise.resolve([]);
        },
        [apolloClient]
    );
};

export default useVaraintImagesOrdering;
